import React from 'react';
import { Button, Modal } from 'react-bootstrap';

/**
 * Модальное окно подтверждения действия
 * @param {boolean} show - Флаг отображения модального окна
 * @param {function} onHide - Функция закрытия модального окна
 * @param {function} onConfirm - Функция подтверждения действия
 * @param {string} title - Заголовок модального окна
 * @param {string} message - Сообщение модального окна
 * @param {string} confirmButtonText - Текст кнопки подтверждения
 * @param {string} cancelButtonText - Текст кнопки отмены
 * @param {string} confirmButtonVariant - Вариант стиля кнопки подтверждения
 * @returns {JSX.Element}
 */
export const ConfirmModal = ({
  show,
  onHide,
  onConfirm,
  title = 'Подтверждение',
  message = 'Вы уверены, что хотите выполнить это действие?',
  confirmButtonText = 'Подтвердить',
  cancelButtonText = 'Отмена',
  confirmButtonVariant = 'danger',
}) => {
  const handleConfirm = () => {
    onConfirm();
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {cancelButtonText}
        </Button>
        <Button variant={confirmButtonVariant} onClick={handleConfirm}>
          {confirmButtonText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
